import React, { Component } from 'react';
import { useScroll } from 'react-router-scroll';
import { Router, browserHistory, applyRouterMiddleware } from 'react-router';
import {
    ApolloClient,
    createNetworkInterface,
    ApolloProvider,
} from 'react-apollo';

const apiUri = process.env.NODE_ENV === 'production' ?
    'https://www.supagemu.com/graphql' :
    'http://localhost:4001/graphql';
const client = new ApolloClient({
    networkInterface: createNetworkInterface({
        uri: apiUri,
    }),
    ssrMode: true,
    initialState: window.__APOLLO_STATE__,
});

export default class Root extends Component {
    props: {
        routes: any,
    };

    render() {
        return (
            <ApolloProvider client={ client }>
                <Router
                    render={ applyRouterMiddleware(useScroll()) }
                    history={ browserHistory }
                    routes={ this.props.routes }
                    { ...this.props }
                />
            </ApolloProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Root.js